<template>
  <!-- <component :is="svg" :width="width" :height="height"/> -->
  <img :src="path" :width="width" :height="height"/>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

const svgAssets = import.meta.glob('/src/assets/**/*.svg', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

@Component
export default class SVG extends Vue {
  @Prop({default:''}) public name:string;
  @Prop({default:null}) public width:number;
  @Prop({default:null}) public height:number;

  public get svg() {    
    return this.path;
  }

  public get path(){
    return svgAssets[`/src/assets/${this.name}.svg`] || '';
  }
}
</script>
